import L from 'leaflet';

export const getAverageGroupPosition = (devices) => {
  if (devices.length === 0) return { lat: 29.798707863118377, lng: -98.29839841752587 };
  const total = devices.reduce(
    (position, device) => ({
      lat: position.lat + Number(device.location.lat),
      lng: position.lng + Number(device.location.lng),
    }),
    { lat: 0, lng: 0 },
  );
  return { lat: total.lat / devices.length, lng: total.lng / devices.length };
};

// Device types bucketed to match backend grouping expectations
export const DEVICE_TYPE_MAP = {
  controllers: ['Stage', 'Monitoring Station', 'Buoy Conditions'],
  devices: [
    'Manual Road Closure',
    'Technology Bridge_Flashing Lights',
    'Technology Bridge_Siren/Giant Voice',
  ],
};

// Normalize form payload into controller/devices/aux buckets expected by the API
export const buildGroupPayload = (formData, connectedDevices = []) => {
  const finalData = {
    ...formData,
    name: formData?.name || 'Unnamed Group',
    controllers: [],
    devices: [],
    aux_devices: [],
    icon_id: 0,
  };

  (formData?.devices || []).forEach((deviceId) => {
    const device = connectedDevices.find((_device) => _device.id === deviceId);
    if (!device) return;

    if (DEVICE_TYPE_MAP.controllers.includes(device.device_type)) {
      finalData.controllers.push(deviceId);
    } else if (DEVICE_TYPE_MAP.devices.includes(device.device_type)) {
      finalData.devices.push(deviceId);
    } else {
      finalData.aux_devices.push(deviceId);
    }
  });

  return finalData;
};

// Pull lat/lng objects for the selected device ids
export const getDeviceLocationsByIds = (deviceIds = [], connectedDevices = []) =>
  deviceIds
    .map((id) => connectedDevices.find((device) => device.id === id))
    .filter((device) => device?.location?.lat && device?.location?.lng)
    .map((device) => ({ lat: device.location.lat, lng: device.location.lng }));

// Given device locations, find a map center and a rough zoom to fit the furthest two points
export const calculateCenterAndZoom = (locations = []) => {
  if (!locations.length) return { center: { lat: 0, lng: 0 }, zoom: undefined };

  if (locations.length < 2) {
    const location = locations[0];
    return {
      center: location ? { lat: location.lat, lng: location.lng } : { lat: 0, lng: 0 },
      zoom: undefined,
    };
  }

  let maxDist = 0;
  let pointA = locations[0];
  let pointB = locations[1];
  for (let i = 0; i < locations.length; i++) {
    for (let j = i + 1; j < locations.length; j++) {
      const dist = L.latLng(locations[i]).distanceTo(L.latLng(locations[j]));
      if (dist > maxDist) {
        maxDist = dist;
        pointA = locations[i];
        pointB = locations[j];
      }
    }
  }

  const bounds = [
    [pointA.lat, pointA.lng],
    [pointB.lat, pointB.lng],
  ];
  const latLngBounds = L.latLngBounds(bounds);
  const centerLatLng = latLngBounds.getCenter();

  const deltaLat = Math.abs(bounds[1][0] - bounds[0][0]);
  const deltaLng = Math.abs(bounds[1][1] - bounds[0][1]);
  const maxDelta = Math.max(deltaLat, deltaLng);
  const zoom = maxDelta ? Math.floor(Math.log((360 * 1.35) / maxDelta) / Math.log(2)) : undefined;

  return {
    center: { lat: centerLatLng.lat, lng: centerLatLng.lng },
    zoom: Number.isFinite(zoom) ? zoom : undefined,
  };
};
